export default __webpack_public_path__ + "static/media/vehicle240.b8e2d7cb.svg";